<template>
  <app-content class="app-home-vue frame-page">
    <template v-if="currentAccountSets">
      <Row :space="24">
        <Cell width="8">
          <div class="h-panel" style="height: 400px">
            <div class="h-panel-bar">
              <div class="h-panel-title">{{ currentAccountSets.currentAccountDate|fqFormat }}</div>
              <div class="h-panel-right"><span class="gray-color">当期有</span><i class="h-split"></i><span class="font20 primary-color">{{ voucherCount }}</span><i class="h-split"></i><span class="gray-color">张凭证</span></div>
            </div>
            <div class="h-panel-body progress-div home-part-body">
              <div class="voucher-add-content" @click="addVouch">
                <img src="../assets/voucherAdd.png" style="width: 120px;height: 120px"/>
                <p>新增凭证</p>
              </div>
            </div>
          </div>
        </Cell>
        <Cell width="16">
          <div class="h-panel">
            <div class="h-panel-body home-part-body2">
              <Row :space="20">
                <Cell :width="24">
                  <Chart :options="revenueProfitOptions"></Chart>
                </Cell>
              </Row>
            </div>
          </div>
        </Cell>
        <Cell width="24">
          <div class="h-panel" style="height: 235px">
            <div class="h-panel-bar">
              <span class="version-text">当前版本号：<strong class="primary-color">{{ currentVersion }}</strong></span>
              <span class="version-divider">。</span>
              <span class="version-text">升级日期：<strong class="primary-color">{{ upgradeDate }}</strong></span>
              <span class="version-divider">。</span>
            </div>
            <div class="h-panel-body version-upgrade-panel">
              <Table :datas="databanben" :border="true" stripe>
                <TableItem title="升级日期" prop="riqi" :width="100" align="center"></TableItem>
                <TableItem title="版本号" prop="banben" :width="100" align="center"></TableItem>
                <TableItem title="升级内容" prop="neirong"></TableItem>
              </Table >
            </div>
          </div>
        </Cell>
<!--        <Cell width="16">-->
<!--          <div class="h-panel" style="height: 235px">-->
<!--            <div class="h-panel-bar">-->
<!--              <div class="h-panel-title">货币资金</div>-->
<!--              <div class="h-panel-right"><span class="gray-color">总资金</span><i class="h-split"></i><span v-tooltip :content="cashTotal" class="font20 primary-color text-hover">{{ cashTotal|moneyFormat }}</span><i class="h-split"></i><span class="gray-color">元</span></div>-->
<!--            </div>-->
<!--            <div class="h-panel-body">-->
<!--              <Row style="line-height: 45px;" type="flex" v-for="cash in cashData" :key="cash.name">-->
<!--                <Cell :flex="1">{{ cash.name }}</Cell>-->
<!--                <Cell><b class="text-hover" v-tooltip :content="cash.value">{{ cash.value|moneyFormat }}</b>元</Cell>-->
<!--              </Row>-->
<!--            </div>-->
<!--          </div>-->
<!--        </Cell>-->
<!--        <Cell width="8">-->
<!--          <div class="h-panel" style="height: 235px">-->
<!--            <div class="h-panel-bar">-->
<!--              <div class="h-panel-title">费用统计</div>-->
<!--              <div class="h-panel-right"><span class="gray-color">总费用</span><i class="h-split"></i><span v-tooltip :content="costTotal" class="font20 primary-color text-hover">{{ costTotal|moneyFormat }}</span><i class="h-split"></i><span class="gray-color">元</span></div>-->
<!--            </div>-->
<!--            <div class="h-panel-body">-->
<!--              <Row style="line-height: 45px;" type="flex" v-for="cash in costData" :key="cash.name">-->
<!--                <Cell :flex="1">{{ cash.name }}</Cell>-->
<!--                <Cell><b class="text-hover" v-tooltip :content="cash.value">{{ cash.value|moneyFormat }}</b>元</Cell>-->
<!--              </Row>-->
<!--            </div>-->
<!--          </div>-->
<!--        </Cell>-->

      </Row>
    </template>
           <!-- 没有账套先注册账套   -->
    <div class="h-panel" v-else>
      <div class="h-panel-bar"><span class="h-panel-title">初始化账套</span></div>
      <div class="h-panel-body">
        <Form ref="form" v-width="800" mode="twocolumn" :labelWidth="150" :model="form" :rules="validationRules">
          <FormItem label="单位名称:" prop="companyName">
            <input type="text" v-model="form.companyName">
          </FormItem>
          <FormItem label="账套启用年月:" prop="enableDate">
            <DatePicker type="month" v-model="form.enableDate"/>
          </FormItem>
          <FormItem label="统一社会信用代码:">
            <input type="text" v-model="form.creditCode">
          </FormItem>
          <FormItem label="会计准则:" prop="accountingStandards">
            <Radio v-model="form.accountingStandards" dict="accountingStandards"></Radio>
          </FormItem>
          <FormItem label="单位所在地:">
            <CategoryPicker ref="CategoryPicker" :option="pickerOption" type="key" showAllLevels v-model="form.address"></CategoryPicker>
          </FormItem>
          <FormItem label="行业:">
            <Select v-model="form.industry" dict="industry"></Select>
          </FormItem>
          <FormItem label="增值税种类:" prop="vatType">
            <Radio v-model="form.vatType" dict="vatRadios"></Radio>
          </FormItem>
          <FormItem label="凭证是否需要审核:" prop="voucherReviewed">
            <Radio v-model="form.voucherReviewed" dict="needRadios"></Radio>
          </FormItem>
          <FormItem single>
            <Button color="green" @click="submit" :loading="loading">创建账套</Button>
          </FormItem>
        </Form>
      </div>
    </div>

  </app-content>
</template>
<script>
import revenueProfit from '../js/data/revenueProfit';
import {getTotalData} from '../js/locations/district';
import {mapState} from 'vuex';
import moment from "moment";

/**
 * 定义一个空的账套初始化表单对象，用于初始化账套创建表单的数据。
 * 该对象包含了创建账套所需的各项基本信息，初始值为默认值或空值。
 */
const emptyForm = {
  // 会计准则，默认值为 "0"
  "accountingStandards": "0",
  // 单位所在地，初始值为 null
  "address": null,
  // 单位名称，初始值为空字符串
  "companyName": "",
  // 统一社会信用代码，初始值为空字符串
  "creditCode": "",
  // 账套启用年月，初始值为 null
  "enableDate": null,
  // 固定资产模块，默认值为 "0"
  "fixedAssetModule": "0",
  // 出纳模块，默认值为 "0"
  "cashierModule": "0",
  // 凭证是否需要审核，默认值为 "0"
  "voucherReviewed": "0",
  // 行业，初始值为空字符串
  "industry": "",
  // 增值税种类，默认值为 "0"
  "vatType": "0"
};


/**
 * 首页
 */
export default {
  name: 'Home',
  data() {
    return {
      revenueProfitOptions: revenueProfit,
      cashData: [{name: '库存现金', value: 0}, {name: '银行存款', value: 0}, {name: '其他货币资金', value: 0}],
      costData: [{name: '销售费用', value: 0}, {name: '管理费用', value: 0}, {name: '财务费用', value: 0}],
      voucherCount: 0,
      loading: false,
      datas: [],
      type: 'type1',
      // 版本信息
      currentVersion: '4.0.2',
      upgradeDate: '2026-09-28',
      upgradeContent: '新增生成报表功能，目前支持生成权责、收付、同步、资产负债报表。优化模块菜单，新增权限菜单',
      pickerOption: {
        keyName: 'id',
        titleName: 'title',
        dataMode: 'list',
        parentName: 'parentId',
        datas: getTotalData()
      },
      databanben:[],
            // 使用 Object.assign 方法创建一个 emptyForm 对象的浅拷贝，将其赋值给 form 数据属性。
      // 这样做可以避免直接修改 emptyForm 原始对象，确保每次初始化 form 时都使用 emptyForm 的初始值。
      form: Object.assign({}, emptyForm),
      // 表单验证规则，包括必填项验证规则。
      validationRules: {
        required: ["companyName", "enableDate", "accountingStandards", "fixed_asset_module", "cashier_module", "voucherReviewed", "vatType"]
      }
    };
  },
  computed: {
    ...mapState(['currentAccountSets']),
    costTotal() {
      let total = 0;
      this.costData.forEach(item => {
        total += item.value;
      });
      return total.toFixed(2);
    },
    cashTotal() {
      let total = 0;
      this.cashData.forEach(item => {
        total += item.value;
      });
      return total.toFixed(2);
    }
  },
  methods: {
    openMore() {
      this.$router.push({name: 'Chart'});
    },
    addVouch() {
      this.$router.push({name: 'VoucherForm'});
    },


    /**
     * 初始化版本升级数据
     * 加载历史版本升级记录，包含升级日期、版本号和升级内容
     */
    initVersionData() {
      this.databanben = [
        {
          riqi: '2026-09-28',
          banben: '4.0.2',
          neirong: '修复跳转页面再录入凭证时，快捷方式不能保存的问题，修复快捷方式重复保存的问题。',
        },
        {
          riqi: '2026-09-16',
          banben: '4.0.0',
          neirong: '新增城市经理经营费用汇总功能。',
        },
        {
          riqi: '2026-08-12',
          banben: '3.9.0',
          neirong: '修改凭证部门和往来输入界面，不选择部门和往来时，不能退出当前选择界面。',
        },
        {
          riqi: '2026-08-11',
          banben: '3.8.6',
          neirong: '修复凭证Enter键选中摘要框不自动复制问题。',
        },
        {
          riqi: '2026-08-01',
          banben: '3.8.5',
          neirong: '修复自动折旧撤销后不能删除未折旧资产问题。',
        },
        {
          riqi: '2026-07-25',
          banben: '3.8.3',
          neirong: '修复分摊医美凭证不保存负数的问题。',
        },
        {
          riqi: '2026-06-25',
          banben: '3.8.2',
          neirong: '部门、往来的新增、编辑增加权限管理。',
        },
        {
          riqi: '2026-06-23',
          banben: '3.8.0',
          neirong: '凭证、分摊医美、自动折旧生成凭证时增加防抖机制。',
        },
        {
          riqi: '2026-06-08',
          banben: '3.7.8',
          neirong: '修复凭证快捷方式保存弹出信息过多，有几率重复保存问题。',
        },
        {
          riqi: '2026-06-03',
          banben: '3.7.6',
          neirong: '收付制去掉200204统计',
        },
        {
          riqi: '2026-05-21',
          banben: '3.7.2',
          neirong: '账套排序',
        },
        {
          riqi: '2026-05-09',
          banben: '3.7.1',
          neirong: '修复预测经营费用批量删除问题。',
        },
        {
          riqi: '2026-05-09',
          banben: '3.7.0',
          neirong: '修复医美分摊不显示部门的问题。',
        },
        {
          riqi: '2026-05-04',
          banben: '3.6.8',
          neirong: '优化医美分摊导入和保存，保留2位小数。',
        },
        {
          riqi: '2026-05-02',
          banben: '3.6.7',
          neirong: '优化计提折旧，结转后不能折旧和反折旧。',
        },
        {
          riqi: '2026-05-01',
          banben: '3.6.5',
          neirong: '修改后端结转损益、拨款、上缴款项，生成凭证问题。',
        },
        {
          riqi: '2026-04-29',
          banben: '3.6.3',
          neirong: '修改前后端结转，反结转判断逻辑，修改当期凭证日期显示逻辑',
        },
        {
          riqi: '2026-04-28',
          banben: '3.6.0',
          neirong: '修改凭证录入部门、往来选择问题，输入模糊代码直接回车',
        },
        {
          riqi: '2026-04-28',
          banben: '3.5.6',
          neirong: '修改同步管理，同步经营的后台逻辑。'
        },
        {
          riqi: '2026-04-28',
          banben: '3.5.5',
          neirong: '修改经营现金，经营存款汇总逻辑。'
        },
        {
          riqi: '2026-04-27',
          banben: '3.5.4',
          neirong: '修改管理部门，管理存款，管理现金，同步管理，预测管理的批量保存和删除功能。'
        },
        {
          riqi: '2026-04-26',
          banben: '3.4.4',
          neirong: '1、优化主页显示，增加版本信息。2、修改同步账套显示模块内容。'
        },
        {
          riqi: '2026-04-23',
          banben: '3.4.1',
          neirong: '修改经营存款批量保存问题'
        }
      ];
    },

        /**
     * 提交账套创建或更新表单
     * 此方法会先对表单进行验证，若验证通过则将启用日期格式化，
     * 接着调用 API 进行账套保存或更新操作，操作完成后根据结果处理页面状态。
     */
    submit() {
      // 调用表单组件的 valid 方法进行表单验证，并将验证结果存储在 validResult 变量中
      let validResult = this.$refs.form.valid();
      // 判断表单验证是否通过
      if (validResult.result) {
        // 若验证通过，开启加载状态，防止用户重复提交
        this.loading = true;
        // 使用 moment.js 将账套启用日期格式化为 "YYYY-MM-DD" 字符串
        this.form.enableDate = moment(this.form.enableDate).format("YYYY-MM-DD");
        // 根据表单中是否存在 id 字段，决定调用更新或保存账套的 API
        this.$api.setting.accountSets[this.form.id ? 'update' : 'save'](this.form)
          .then(() => {
            // 若 API 调用成功，关闭加载状态
            this.loading = false;
            // 刷新当前页面，使页面数据更新
            window.location.reload();
          })
          .catch(() => {
            // 若 API 调用失败，关闭加载状态
            this.loading = false;
          });
      }
    },

    init() {
      if (this.currentAccountSets) {
        Promise.all([
          Api.home.voucherCount(),
          Api.home.chart.revenueProfit(),
          Api.home.chart.cost(),
          Api.home.chart.cash(),
        ]).then((reslut) => {
          this.voucherCount = reslut[0].data;
          this.updateRevenueProfitOptions(reslut[1].data);

          this.cashData = reslut[3].data;
          this.costData = reslut[2].data;
        });
      }
    },
    updateRevenueProfitOptions(chartData) {
      let lr = chartData["本年利润"];
      let zysr = chartData["主营业务收入"];
      let opt = Object.assign({}, this.revenueProfitOptions);
      if (lr) {
        Object.keys(lr).forEach(value => {
          opt.series[1].data[value - 1] = (lr[value] / 1000).toFixed(2);
        });
      }
      if (zysr) {
        Object.keys(zysr).forEach(value => {
          opt.series[0].data[value - 1] = (zysr[value] / 1000).toFixed(2);
        });
      }
      this.revenueProfitOptions = opt;
    }
  },
  mounted() {
    this.init();
    this.initVersionData();
  }
};
</script>
<style lang="less" scoped>.home-part-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100% - 50px);
  box-sizing: border-box;
}

.voucher-add-content {
  text-align: center;
  cursor: pointer;
  padding: 20px;
  border-radius: 8px;
  transition: all 0.3s;

  &:hover {
    background-color: rgba(24, 144, 255, 0.05);
  }

  img {
    margin-bottom: 10px;
  }

  p {
    margin: 0;
    font-size: 16px;
    color: #333;
  }
}
.version-upgrade-panel {
  padding: 10px;

  .version-info {
    margin-bottom: 15px;
    font-size: 14px;
    color: #333;

    .version-text {
      font-weight: normal;
    }

    strong {
      font-weight: 600;
      color: #1890ff;
    }

    .version-divider {
      margin: 0 5px;
    }
  }

  .version-table {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    overflow: hidden;

    .version-table-header {
      display: flex;
      background-color: #fafafa;
      border-bottom: 1px solid #e8e8e8;

      .header-cell {
        font-weight: 600;
        color: #333;
      }
    }

    .version-table-row {
      display: flex;

      &:not(:last-child) {
        border-bottom: 1px solid #e8e8e8;
      }
    }

    .version-table-cell {
      padding: 12px 16px;
      font-size: 13px;
      line-height: 1.6;
      color: #666;

      &.version-cell {
        width: 120px;
        min-width: 120px;
        border-right: 1px solid #e8e8e8;
        color: #333;
      }

      &.content-cell {
        flex: 1;
      }
    }
  }
}
</style>
